import Vue from 'vue'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    lastUpdatedDateVoc: '',
    lastUpdatedDateVoe: '',
    vocAiUsage: {
      usedQueries: 0,
      limitQueries: 10000,
      remainingQueries: 10000,
      usagePercent: 0,
      quotaReached: false
    }
  },
  actions: {
    /** This method returns the date of the last time the database was refreshed */
    getLastUpdatedDateVoc ({ commit }, value) {
      let date = ''
      Vue.prototype.$http.get('/review/getLatestReviewDate').then((response) => {
        if (response.data.status === 200) {
          if (response.data && response.data.data) {
            date = response.data.data.latestDate
            commit('LAST_UPDATED_DATE_VOC', moment(date).format('MM-DD-YYYY'))
          }
        }
      }).catch(e => {
      })
    },
    /** This method returns the date of the last time the database was refreshed for the Voe module */
    getLastUpdatedDateVoe ({ commit }, value) {
      let date = ''
      Vue.prototype.$http.get('/review/getLatestReviewDateVoe').then((response) => {
        if (response.data.status === 200) {
          if (response.data && response.data.data) {
            date = response.data.data.latestDate
            commit('LAST_UPDATED_DATE_VOE', moment(date).format('MM-DD-YYYY'))
          }
        }
      }).catch(e => {
      })
    },
    getVocAiUsage ({ commit }) {
      Vue.prototype.$http.get('/voc/ai-usage').then((response) => {
        if (response.data.status === 200) {
          const usage = response.data && response.data.data ? response.data.data : {}
          commit('SET_VOC_AI_USAGE', {
            usedQueries: Number(usage.used_queries || 0),
            limitQueries: Number(usage.limit_queries || 10000),
            remainingQueries: Number(usage.remaining_queries || 0),
            usagePercent: Number(usage.usage_percent || 0),
            quotaReached: !!usage.quota_reached
          })
        }
      }).catch(e => {
      })
    }
  },
  mutations: {
    LAST_UPDATED_DATE_VOC (state, payload) {
      state.lastUpdatedDateVoc = payload
    },
    LAST_UPDATED_DATE_VOE (state, payload) {
      state.lastUpdatedDateVoe = payload
    },
    SET_VOC_AI_USAGE (state, payload) {
      state.vocAiUsage = payload
    }
  }
}
